import { IEntitySchemaDefinition } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

const Fieldset = ui.S9Fieldset.default;
const S9PageSection = ui.S9PageSection.default;

type Props = {
  schema: IEntitySchemaDefinition | undefined;
};
const CountrySetupForm = ({ schema }: Props) => {
  const fields = [
    {
      field: 'country',
      colSize: 8,
      isReadOnly: true,
    },
    {
      field: 'last_published_dt',
      colSize: 8,
      isReadOnly: true,
    },
    {
      field: 'last_published_by_id',
      colSize: 8,
      isReadOnly: true,
    },
    {
      field: 'employee_count_1_question',
      colSize: 8,
    },
    {
      field: 'employee_count_2_question',
      colSize: 8,
    },
    {
      field: 'employee_count_3_question',
      colSize: 8,
    },
    {
      field: 'apprentice_count_1_question',
      colSize: 8,
    },
    {
      field: 'apprentice_count_2_question',
      colSize: 8,
    },
    {
      field: 'apprentice_count_3_question',
      colSize: 8,
    },
    {
      field: 'certificate_logo',
      colSize: 12,
    },
    {
      field: 'download_seals',
      colSize: 12,
    },
    {
      field: 'certificate_signature',
      colSize: 12,
    },
  ];

  return (
    <S9PageSection title="" size="sm">
      {schema && (
        <Fieldset
          context={{ id: undefined }}
          schema={schema}
          formFields={fields}
        />
      )}
    </S9PageSection>
  );
};

export default CountrySetupForm;
